import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineSmallOneLineWithTextCompactProps } from './types';
import { isNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';

export const HeadlineSmallOneLineWithTextCompact = ({
  header,
}: HeadlineSmallOneLineWithTextCompactProps) => {
  if (isNil(header)) return null;

  return (
    <Flex.Row
      padding={{ horizontal: 16, top: 16, bottom: 8 }}
      justifyContent={'space-between'}
      alignItems={'center'}
      testID={header.item.title}
    >
      <Typography type="h5" color="content_primary">
        {header.item.title}
      </Typography>

      {header.item.text && (
        <HTMLText type="body2" color="content_secondary">
          {header.item.text}
        </HTMLText>
      )}
    </Flex.Row>
  );
};
